import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface MessageAvatarProps {
  isFromAgent: boolean;
  avatarUrl?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  size?: "sm" | "xs";
}

export function MessageAvatar({ 
  isFromAgent, 
  avatarUrl, 
  firstName, 
  lastName,
  size = "xs"
}: MessageAvatarProps) {
  const getInitials = () => {
    // Try to get initials from name first
    const first = firstName?.charAt(0)?.toUpperCase() || "";
    const last = lastName?.charAt(0)?.toUpperCase() || "";
    
    if (first || last) {
      return first + last || first || last;
    }
    
    // Fallback for agents without name
    if (isFromAgent) {
      return "C"; // Concierge
    }
    
    return "U"; // User
  };

  const sizeClasses = size === "xs" 
    ? "h-5 w-5 text-[8px]" 
    : "h-6 w-6 text-[10px]";


  return (
    <Avatar className={`${sizeClasses} shrink-0`}>
      <AvatarImage src={avatarUrl || undefined} alt="Avatar" />
      <AvatarFallback 
        className={`${isFromAgent ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground"} font-medium`}
      >
        {getInitials()}
      </AvatarFallback>
    </Avatar>
  );
}
